<template>
  <div v-outside-click="hideContextMenu" style="position: relative">
    <sub-context :data="data" :depth="0" @hide-subcontext-menu="hideContextMenu" />
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes, TreeDefaultNodeIds } from "../../utils/constants";
import { icons, ProcessItemTypes, ProcessTypes } from "../../utils/icons";
import SubContext from "../redZone/content/SubContext.vue";
export default {
  components: { SubContext },
  props: [],
  data() {
    return {
      index: -1,
      data: [
        {
          id: 202,
          icon: `${icons[ProcessItemTypes.Normal]}`,
          title: this.$t("contextMenu.normalProcess"),
          shortcut: "nn",
          func: () => this.addProcess(ProcessTypes.Normal),
          testId: "noDesign-new-normal-process",
        },
        {
          id: 201,
          icon: `${icons[ProcessItemTypes.Posting]}`,
          title: this.$t("contextMenu.postingProcess"),
          shortcut: "np",
          func: () => this.addProcess(ProcessTypes.Posting),
          testId: "noDesign-new-posting-process",
        },
        {
          id: 203,
          icon: `${icons[ProcessItemTypes.Grid]}`,
          title: this.$t("contextMenu.grid"),
          shortcut: "ng",
          func: this.addGrid,
          testId: "noDesign-new-grid",
        },
      ],
    };
  },

  beforeUnmount() {
    this.resetHotkeyScope();
  },
  methods: {
    clickOutside() {
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },

    addProcess(type) {
      this.$store.dispatch("processes/addProcess", {
        id: TreeDefaultNodeIds.Private,
        type,
      });
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
    addGrid() {
      this.$store.dispatch("grids/addGrid", TreeDefaultNodeIds.Private);
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
    resetHotkeyScope() {
      this.$store.dispatch("setScope", HotkeyScopes.Sidebar.Processes);
      this.index = -1;
    },
    hideContextMenu() {
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
  },
};
</script>
